import { Component, OnInit, NgZone, type ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import {
  DatatableComponent,
  DatatableRowDetailDirective,
} from '@swimlane/ngx-datatable';
import { SettingsService } from '../../settings/settings.service';

@Component({
  selector: 'app-buyer-service-rfq-list',
  templateUrl: './buyer-service-rfq-list.component.html',
  styleUrls: ['./buyer-service-rfq-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyerServiceRfqListComponent implements OnInit {
  @ViewChild('archivedSection', { static: false })
  archivedSection!: ElementRef;
  @ViewChild('heading', { static: false })
  heading!: ElementRef;
  @ViewChild('myDetailRow') table!: DatatableComponent;
  @ViewChild('myDetailRow', { static: false })
  rowDetail!: DatatableRowDetailDirective;
  menuTrigger: MatMenuTrigger | null = null;

  showLoader: boolean = false;
  searchKeyword: string = '';

  limit: number = 10;
  offset: number = 0;
  archivedLimit: number = 10;
  archivedOffset: number = 0;
  totalRecords: number = 0;
  archivedTotalRecords: number = 0;
  sortField: string = 'serviceRfqDate';
  sortDirection: string = 'desc';
  docStatus: string = '';
  fromDate: any;
  toDate: any;
  archivedLoaded: boolean = false;

  allDocumentData: any[] = [];
  documentData: any[] = [];
  archivedDocumentData: any[] = [];
  documentDataTotalRecords: number = 0;
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  searchParam: string = '';
  selectedRfq: number[] = [];
  selectedRfqDetails: number[] = [];
  selectedArchivedRfq: number[] = [];
  selectedArchivedRfqDetails: number[] = [];
  selectedStatus: string[] = ['ALL'];

  rfqStagesList = [
    { name: 'Unactioned', heading: 'RFQ Submitted to Supplier:' },
    { name: 'Created', heading: 'RFQ Created:' },
    { name: 'Draft', heading: 'RFQ Drafted:' },
    { name: 'Sent', heading: 'RFQ Sent:' },
    { name: 'Expired', heading: 'RFQ Expired:' },
    { name: 'Canceled', heading: 'RFQ Canceled:' },
  ];

  quoteStagesList = [
    { name: 'Accepted', heading: 'Quotation Received' },
    { name: 'Declined', heading: 'Quotation Declined:' },
    { name: 'Draft', heading: 'Quotation Drafted:' },
    { name: 'Quoted', heading: 'Quotation Submitted' },
    { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
  ];

  rfqStatuses: string[] = [
    'Draft', 'Acknowledged', 'Quoted', 'Accepted',
    'Declined', 'Expired', 'Sent', 'Created',
    'Pending', 'Withdrawn', 'Unactioned', 'Revised', 'Cancelled',
    'Received', 'Canceled',
  ];

  filterStatuses = [
    { name: 'Submitted', label: 'RFQ' },
    { name: 'Draft', label: 'RFQ' },
    { name: 'Expired', label: 'RFQ' },
    { name: 'Cancelled', label: 'RFQ' },
    { name: 'ALL', label: 'RFQ' },
  ];

  activeIndex: number = this.filterStatuses.length - 1;
  activeIndexes: number[] = [this.filterStatuses.length - 1];

  statusColors: { [key: string]: string } = {
    Submitted: '#69d1d1',
    Draft: '#1868db',
    Expired: '#202020',
    Cancelled: '#dd1102',
  };

  buyerUsersList: any[] = [];
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  isLoading: boolean = false;

  headerData: any;
  isChatOpen: boolean = false;
  userRole!: string;
  userId!: number;
  newMessage = '';
  messages: { sender: string; message: string; time: string }[] = [];
  showChatHistoryButton: boolean = false;
  rfqId!: number;

  rfqTypeDropdownOpen: boolean = false;

  showConfirmationDialogue: boolean = false;
  cancelReason: string = '';
  customReason: string = '';
  selectedRfqStatus: string = '';
  selectedServiceRfqId: number = 0;

  previewSection = false;
  previewDocs: string[] = [];

  showContactPopup: boolean = false;
  selectedSupplier: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax: 'N/A',
  };

  masterSelected: boolean = false;
  selectedSuppliers: any[] = [];
  selectedSupplierForReminders: any[] = [];

  items = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'assignedUsers', selected: false },
  ];

  archivedItems = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'assignedUsers', selected: false },
  ];

  selectedColumns: { label: string; prop: string }[] = [];
  archivedSelectedColumns: { label: string; prop: string }[] = [];

  expandedQuoteId: number | null = null;

  // Stable row identity for ngx-datatable to reduce DOM churn
  rowIdentity = (row: any) => row?.serviceRfqId ?? row?.id;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private snack: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private settingsService: SettingsService
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
    );
  }

  ngOnInit() {
    this.userId = Number(this.cookieService.get('userId'));
    this.userRole = this.cookieService.get('userRole');

    if (this.userRole === 'Buyers') {
      this.showChatHistoryButton = true;
    }

    this.route.queryParams.subscribe((params) => {
      const statusParam = params['selectedStatus'];
      const labelParam = params['label'];

      if (statusParam && labelParam) {
        this.docStatus = statusParam !== 'ALL' ? statusParam : '';
        this.selectedStatus = [statusParam];
        const index = this.filterStatuses.findIndex(
          (s) => s.name.toLowerCase() === statusParam.toLowerCase()
        );
        this.activeIndex = index >= 0 ? index : this.filterStatuses.length - 1;
        this.activeIndexes = [this.activeIndex];
      }
    });

    // Load data from API
    this.loadData();
  }

  async loadData() {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const fromDateFormatted = this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : null;
      const toDateFormatted = this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : null;

      const response = await this.settingsService.fetchAllServiceRfqByBuyerId(
        this.searchParam,
        this.userId,
        this.docStatus,
        fromDateFormatted,
        toDateFormatted,
        this.sortField,
        this.sortDirection,
        this.limit,
        this.offset,
        1 // isActive = 1 for active records
      );

      if (response && response.rows) {
        // Map the response data to include additional UI properties
        this.documentData = response.rows.map((row: any) => this.mapRowData(row));
        this.totalRecords = response.totalElements || 0;

        // Auto-expand first row
        if (this.documentData.length > 0) {
          const first = this.documentData[0];
          this.expandedQuoteId = first.id;
          first.statusesStages = this.buildRfqStages(first);
          first.statusesStages = this.buildOtherStages(first);
        }
      } else {
        this.documentData = [];
        this.totalRecords = 0;
      }
    } catch (error) {
      console.error('Error loading service RFQ data:', error);
      this.snack.open('Error loading data. Please try again.', 'OK', { duration: 3000 });
      this.documentData = [];
      this.totalRecords = 0;
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async loadArchivedData() {
    try {
      const fromDateFormatted = this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : null;
      const toDateFormatted = this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : null;

      const response = await this.settingsService.fetchAllServiceRfqByBuyerId(
        this.searchParam,
        this.userId,
        this.docStatus,
        fromDateFormatted,
        toDateFormatted,
        this.sortField,
        this.sortDirection,
        this.archivedLimit,
        this.archivedOffset,
        0 // isActive = 0 for archived records
      );

      if (response && response.rows) {
        this.archivedDocumentData = response.rows.map((row: any) => this.mapRowData(row));
        this.archivedTotalRecords = response.totalElements || 0;
      } else {
        this.archivedDocumentData = [];
        this.archivedTotalRecords = 0;
      }
    } catch (error) {
      console.error('Error loading archived service RFQ data:', error);
      this.archivedDocumentData = [];
      this.archivedTotalRecords = 0;
    } finally {
      this.cdr.markForCheck();
    }
  }

  mapRowData(row: any): any {
    // Calculate remaining time
    const remaining = this.calculateRemainingTime(row.quotedByDate);

    return {
      ...row,
      id: row.serviceRfqId || row.id,
      serviceRfqId: row.serviceRfqId || row.id,
      serviceRfqDetailsId: row.rfqDetailsId || row.serviceRfqId,
      serviceRfqRefNumber: row.rfqRefNumber,
      serviceRfqDate: row.rfqDate,
      serviceRfqDateFormatted: row.rfqDate ? moment(row.rfqDate).format('DD/MM/YYYY') : '',
      statusColor: this.getStatusColor(row.docStatus),
      remaining: remaining,
      remainingQuote: remaining,
      buyerAttachments: row.buyerAttachments || [],
      lineItemAttachments: row.lineItemAttachments || [],
      rfqStatusStages: row.rfqStatusStages || [],
      suppliers: (row.suppliers || []).map((s: any) => ({ ...s, selected: false })),
      statusesStages: null,
    };
  }

  calculateRemainingTime(quotedByDate: any): { label: string; color: string; tooltip: string } {
    if (!quotedByDate) {
      return { label: '', color: '#000000', tooltip: '' };
    }

    const now = moment();
    const dueDate = moment(quotedByDate);
    const diffDays = dueDate.diff(now, 'days');

    if (diffDays < 0) {
      return { label: 'Overdue', color: '#000000', tooltip: `Overdue by ${Math.abs(diffDays)} days` };
    } else if (diffDays <= 3) {
      return { label: 'Urgent', color: '#F60303', tooltip: `Due in ${diffDays} days` };
    } else if (diffDays <= 7) {
      return { label: 'Standard', color: '#FD8900', tooltip: `Due in ${diffDays} days` };
    } else {
      return { label: 'New', color: '#0BA716', tooltip: `Due in ${diffDays} days` };
    }
  }

  get userIdAsString(): string {
    return this.userId.toString();
  }

  // Status color getter
  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000';
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment();
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    if (diffInSeconds < 60) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (${diffInSeconds} seconds ago)`;
    } else if (diffInMinutes < 60) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (${diffInMinutes} minutes ago)`;
    } else if (diffInHours < 24) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (${diffInHours} hours ago)`;
    } else if (diffInDays === 1) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (Yesterday)`;
    } else {
      return moment(rfqDate).format('DD MMM YYYY');
    }
  }

  onStatusSelect(status: string, index: number, label: string) {
    this.activeIndex = index;
    if (label === 'RFQ') {
      if (this.selectedStatus.includes(status)) {
        return;
      }
      if (status !== 'ALL') {
        this.docStatus = status;
      } else {
        this.docStatus = '';
      }
      this.selectedStatus = [status];
      this.activeIndexes = [index];
      this.expandedQuoteId = null;
      this.offset = 0;
      this.loadData();
    } else if (label === 'Quote') {
      // Navigate to service quote list when implemented
      this.snack.open('Service Quote List - Coming Soon', 'OK', { duration: 2000 });
    }
  }

  toggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateSelectedColumns();
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateArchivedSelectedColumns();
  }

  updateSelectedColumns() {
    this.selectedColumns = this.items
      .filter((item) => item.selected)
      .map((item) => ({ label: item.label, prop: item.prop }));
  }

  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter((item) => item.selected)
      .map((item) => ({ label: item.label, prop: item.prop }));
  }

  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  onPageChange(event: any) {
    this.offset = event.offset;
    this.selectedRfq = [];
    this.loadData();
  }

  onSearch() {
    this.offset = 0;
    this.archivedOffset = 0;
    this.loadData();
    if (this.archivedLoaded) {
      this.loadArchivedData();
    }
  }

  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    this.offset = 0;
    this.loadData();
    if (this.archivedLoaded) {
      this.archivedOffset = 0;
      this.loadArchivedData();
    }
  }

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset;
    this.loadArchivedData();
  }

  setRowClass = (row: any) => {
    return 'green-row-background';
  };

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand) {
      if (!this.archivedLoaded) {
        this.archivedLoaded = true;
        this.loadArchivedData();
      }
      if (this.heading) {
        this.heading.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }

  cancelFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.selectedStatus = ['ALL'];
    this.docStatus = '';
    this.searchParam = '';
    this.loadData();
    if (this.archivedLoaded) {
      this.loadArchivedData();
    }
  }

  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;

    if (section === 'active') {
      if (checked) {
        this.selectedRfq = this.documentData.map((item) => item.serviceRfqId);
        this.selectedRfqDetails = this.documentData.map((item) => item.serviceRfqDetailsId);
      } else {
        this.selectedRfq = [];
        this.selectedRfqDetails = [];
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq = this.archivedDocumentData.map((item) => item.serviceRfqId);
        this.selectedArchivedRfqDetails = this.archivedDocumentData.map((item) => item.serviceRfqDetailsId);
      } else {
        this.selectedArchivedRfq = [];
        this.selectedArchivedRfqDetails = [];
      }
    }
  }

  selectDeselectRfq(event: any, rfqDetailsId: any, rfqId: any, section: string, assignedUsers: any) {
    const checked = event.target.checked;

    if (section === 'active') {
      if (checked) {
        this.selectedRfq.push(rfqId);
        this.selectedRfqDetails.push(rfqDetailsId);
        if (assignedUsers && assignedUsers.trim() !== '') {
          this.snack.open(`Note: Service RFQ ${rfqId} already has assigned user(s): ${assignedUsers}`, 'OK', {
            duration: 5000,
          });
        }
      } else {
        this.selectedRfq = this.selectedRfq.filter((id) => id !== rfqId);
        this.selectedRfqDetails = this.selectedRfqDetails.filter((id) => id !== rfqDetailsId);
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq.push(rfqId);
        this.selectedArchivedRfqDetails.push(rfqDetailsId);
      } else {
        this.selectedArchivedRfq = this.selectedArchivedRfq.filter((id) => id !== rfqId);
        this.selectedArchivedRfqDetails = this.selectedArchivedRfqDetails.filter((id) => id !== rfqDetailsId);
      }
    }
  }

  isChecked(rfqId: number, section: string) {
    if (section === 'active') {
      return this.selectedRfq.includes(rfqId);
    } else {
      return this.selectedArchivedRfq.includes(rfqId);
    }
  }

  openRfqDetails(serviceRfqId: number) {
    this.router.navigate(['/dashboard/rfq/service-rfq-header'], {
      queryParams: { serviceRfqId },
    });
  }

  toggleExpandedRow(row: any) {
    this.expandedQuoteId = this.expandedQuoteId === row.id ? null : row.id;
    if (this.expandedQuoteId === row.id && !row.statusesStages) {
      row.statusesStages = this.buildRfqStages(row);
      row.statusesStages = this.buildOtherStages(row);
    }
  }

  buildRfqStages(rfq: any) {
    const stagesArray: any[] = [];

    let rfqCount = 0;
    if (rfq.suppliers?.length > 0) {
      rfqCount = rfq.suppliers.length;
    }

    const sortedStages = (rfq.rfqStatusStages || []).slice().sort(
      (a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );

    if (sortedStages.length > 0) {
      // Dynamic stage building from API data
      sortedStages.forEach((stage: any) => {
        stagesArray.push({
          heading: this.getHeadingFromLabel(stage.statusName, 'RFQ'),
          label:
            stage.statusName === 'Unactioned'
              ? `RFQ Sent(${rfqCount})`
              : `RFQ ${stage.statusName}`,
          date: this.formatDate(stage.createdAt),
          completed: true,
        });
      });
    } else {
      // Fallback: build stages based on docStatus
      stagesArray.push({
        heading: 'RFQ Created:',
        label: 'RFQ Created',
        date: this.formatDate(rfq.serviceRfqDate),
        completed: true,
      });

      if (rfq.docStatus === 'Submitted') {
        stagesArray.push({
          heading: 'RFQ Sent:',
          label: rfqCount > 0 ? `RFQ Sent(${rfqCount})` : 'RFQ Sent',
          date: this.formatDate(rfq.serviceRfqDate),
          completed: true,
        });
      } else if (rfq.docStatus === 'Draft') {
        stagesArray.push({
          heading: 'RFQ Drafted:',
          label: 'RFQ Drafted',
          date: this.formatDate(rfq.serviceRfqDate),
          completed: true,
        });
      } else if (rfq.docStatus === 'Cancelled') {
        stagesArray.push({
          heading: 'RFQ Cancelled:',
          label: 'RFQ Cancelled',
          date: '',
          completed: true,
        });
      } else {
        stagesArray.push({
          heading: 'RFQ Sent:',
          label: rfqCount > 0 ? `RFQ Sent(${rfqCount})` : 'RFQ Sent',
          date: '',
          completed: false,
        });
      }
    }

    // Auto-detect expiration
    if (
      (rfq.docStatus === 'Unactioned' || rfq.docStatus === 'Expired' || rfq.docStatus === 'Submitted') &&
      this.isRfqLapsed(rfq.quotedByDate) &&
      !stagesArray.some((s) => s.label === 'RFQ Expired')
    ) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Expired', 'RFQ'),
        label: 'RFQ Expired',
        date: this.formatDate(rfq.quotedByDate),
        completed: true,
      });
    }

    return stagesArray;
  }

  buildOtherStages(rfq: any) {
    let stagesArray = rfq.statusesStages || [];

    let quoteCount = 0;
    let latestQuoteDate = '';
    if (rfq.suppliers?.length > 0) {
      for (let supplier of rfq.suppliers) {
        if (supplier.rfqStatus === 3) { // 3 = Quoted
          quoteCount++;
          latestQuoteDate = supplier.quotationDate || supplier.responseTime || '';
        }
      }
    }

    if (quoteCount > 0) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Accepted', 'Quote'),
        label: `Quotation received(${quoteCount})`,
        date: latestQuoteDate ? this.formatDate(latestQuoteDate) : '',
        completed: true,
      });
    } else {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Accepted', 'Quote'),
        label: 'Quotation received(0)',
        date: '',
        completed: false,
      });
    }

    stagesArray.push({
      heading: 'PO Created',
      label: 'PO Created',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'PO Sent',
      label: 'PO Sent',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'Delivered',
      label: 'Delivered',
      date: '',
      completed: false,
    });

    return stagesArray;
  }

  formatDate(date: string | Date): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-GB');
  }

  getStageColorClass(label: string, row: any): string {
    if (row.docStatus === 'Cancelled') {
      return 'stage-declined';
    }
    switch (label) {
      case 'RFQ Cancelled':
        return 'stage-declined';
      case 'RFQ Expired':
        return 'stage-lapsed';
      default:
        return 'stage-completed';
    }
  }

  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  getHeadingFromLabel(label: string, entityType: 'RFQ' | 'Quote'): string {
    const list =
      entityType === 'RFQ' ? this.rfqStagesList : this.quoteStagesList;
    const match = list.find(
      (stage) => stage.name.toLowerCase() === label.toLowerCase()
    );
    return match ? match.heading : label;
  }

  isRfqLapsed(quotedByDate: string | Date): boolean {
    if (!quotedByDate) return false;
    return new Date() > new Date(quotedByDate);
  }

  // Supplier Selection Methods
  selectAllSuppliers(suppliers: any[]) {
    suppliers.forEach((supplier: any) => {
      if (supplier.rfqStatus !== 15) {
        supplier.selected = this.masterSelected;
      }
    });
    this.updateSelectedSuppliers(suppliers);
  }

  checkIfAllSelected(suppliers: any[]) {
    this.masterSelected = suppliers
      .filter((s: any) => s.rfqStatus !== 15)
      .every((s: any) => s.selected);
    this.updateSelectedSuppliers(suppliers);
  }

  updateSelectedSuppliers(suppliers: any[]) {
    this.selectedSuppliers = suppliers.filter(
      (supplier: any) => supplier.selected && supplier.rfqStatus !== 15
    );

    this.selectedSupplierForReminders = this.selectedSuppliers.filter(
      (supplier: any) =>
        (supplier.quoteStatus !== null && supplier.quoteStatus !== 3) ||
        (supplier.quoteStatus === null && (supplier.rfqStatus === 2 || supplier.rfqStatus === null))
    );
  }

  getSupplierStatus(supplier: any): string {
    if (supplier.quoteId != null) {
      return this.rfqStatuses[supplier.quoteStatus - 1] || 'N/A';
    } else if (supplier.rfqStatus != null) {
      return this.rfqStatuses[supplier.rfqStatus - 1] || 'N/A';
    }
    return 'Unactioned';
  }

  // User Assignment Methods
  async toggleUserSelection(user: any) {
    if (this.selectedRfq.length === 0) {
      this.snack.open('Please select at least one Service RFQ before selecting a user.', 'OK', {
        duration: 3000,
      });
      return;
    }

    user.selected = !user.selected;

    if (user.selected) {
      await this.assignUserToSelectedRfqs(user);
    } else {
      await this.unassignUserFromSelectedRfqs(user);
    }
  }

  async assignUserToSelectedRfqs(user: any) {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      for (const serviceRfqId of this.selectedRfq) {
        await this.settingsService.assignUserToBuyerServiceRfq(
          serviceRfqId,
          user.id,
          this.userId
        );
      }

      this.snack.open(`User ${user.firstName} ${user.lastName} assigned to ${this.selectedRfq.length} RFQ(s).`, 'OK', { duration: 3000 });

      await this.loadData();

      this.selectedRfq = [];
      this.selectedRfqDetails = [];
    } catch (error) {
      console.error('Error assigning user:', error);
      this.snack.open('Error assigning user. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async unassignUserFromSelectedRfqs(user: any) {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      for (const serviceRfqId of this.selectedRfq) {
        await this.settingsService.unassignUserFromBuyerServiceRfq(
          serviceRfqId,
          user.id
        );
      }

      this.snack.open(`User ${user.firstName} ${user.lastName} unassigned from ${this.selectedRfq.length} RFQ(s).`, 'OK', { duration: 3000 });

      await this.loadData();

      this.selectedRfq = [];
      this.selectedRfqDetails = [];
    } catch (error) {
      console.error('Error unassigning user:', error);
      this.snack.open('Error unassigning user. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async bulkAssignUsers() {
    if (this.selectedRfq.length === 0) {
      this.snack.open('Please select at least one Service RFQ.', 'OK', { duration: 3000 });
      return;
    }

    const selectedUserIds = this.buyerUsersList
      .filter((u: any) => u.selected)
      .map((u: any) => u.id)
      .join(',');

    if (!selectedUserIds) {
      this.snack.open('Please select at least one user to assign.', 'OK', { duration: 3000 });
      return;
    }

    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      for (const serviceRfqId of this.selectedRfq) {
        await this.settingsService.bulkAssignUsersToBuyerServiceRfq(
          serviceRfqId,
          selectedUserIds,
          this.userId
        );
      }

      this.snack.open('Users assigned successfully.', 'OK', { duration: 3000 });
      await this.loadData();

      this.selectedRfq = [];
      this.selectedRfqDetails = [];
      this.buyerUsersList.forEach((u: any) => u.selected = false);
    } catch (error) {
      console.error('Error bulk assigning users:', error);
      this.snack.open('Error assigning users. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  onScroll(): void {
    const menuContent = document.querySelector('.menu-content') as HTMLElement;
    if (
      menuContent &&
      menuContent.scrollTop + menuContent.clientHeight >= menuContent.scrollHeight &&
      !this.isLoading
    ) {
      if (this.buyerUsersList.length === this.userlimit * this.useroffset) {
        this.fetchMoreUsers();
      }
    }
  }

  async fetchMoreUsers(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.settingsService.fetchUserBySupplierId(
        this.userId,
        this.userlimit,
        this.useroffset
      ).toPromise();

      if (response && Array.isArray(response.rows)) {
        this.buyerUsersList = [...this.buyerUsersList, ...response.rows];
        this.useroffset++;
      }
    } catch (error) {
      console.error('Error fetching more users:', error);
    } finally {
      this.isLoading = false;
      this.cdr.markForCheck();
    }
  }

  onUserMenuOpened() {
    this.settingsService.fetchUserBySupplierId(
      this.userId,
      this.userlimit,
      this.useroffset
    ).subscribe({
      next: (response) => {
        if (response && response.rows) {
          this.buyerUsersList = response.rows.map((user: any) => ({
            ...user,
            selected: false
          }));
        }
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Error loading buyer users:', error);
        this.buyerUsersList = [];
        this.cdr.markForCheck();
      }
    });
  }

  onReminderClick(row: any) {
    this.snack.open('Reminder functionality - Coming Soon', 'OK', { duration: 2000 });
  }

  openChat(rfq: any) {
    this.snack.open('Chat functionality - Coming Soon', 'OK', { duration: 2000 });
  }

  closeChat() {
    this.isChatOpen = false;
  }

  toggleRfqTypeDropdown() {
    this.rfqTypeDropdownOpen = !this.rfqTypeDropdownOpen;
  }

  navigateToRfqType(type: string) {
    if (type === 'product') {
      this.router.navigate(['/operations/buyer-rfq-list']);
    } else if (type === 'service') {
      this.router.navigate(['/operations/buyer-service-rfq-list']);
    }
  }

  togglePreview(value: boolean, row?: any) {
    this.previewSection = value;
    this.previewDocs = [];
    if (row) {
      this.previewDocs = [...(row.buyerAttachments || []), ...(row.lineItemAttachments || [])];
    }
  }

  toggleContactPopUp(value: boolean, row?: any) {
    this.showContactPopup = value;
    if (value && row) {
      this.selectedSupplier = {
        companyName: row.supplierCompanyName || 'N/A',
        contactPerson: row.supplierContact || 'N/A',
        email: row.supplierEmail || 'N/A',
        phone: row.supplierPhone || 'N/A',
        address: row.supplierAddress || 'N/A',
        fax: row.supplierFax || 'N/A',
      };
    }
  }

  async downloadRfq(rfqDetailsId: number, refNo: string) {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const fileName = refNo + '.pdf';

      const pdf = await this.settingsService.generateBuyerServiceRfqAttachment(
        rfqDetailsId,
        this.userId
      );

      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.snack.open('PDF downloaded successfully.', 'OK', { duration: 3000 });
    } catch (error) {
      console.error('Error downloading Service RFQ PDF:', error);
      this.snack.open('Error downloading PDF. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async generateRFQExcelForBuyer(rfqId: number, refNo: string) {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const result = await this.settingsService.fetchBuyerServiceRfqDetailsForExcel(
        rfqId,
        this.userId
      );

      if (!result || !result.rfqData || result.rfqData.length === 0) {
        this.snack.open('No data found for this Service RFQ.', 'OK', { duration: 3000 });
        return;
      }

      const fileName = refNo + '.xlsx';

      const labelMap: { [key: string]: string } = {
        name: 'Name',
        address: 'Address',
        contact: 'Contact',
        phone: 'Phone',
        email: 'Email',
        mpsBuyerCode: 'MPS Buyer Code',
        mpsSupplierCode: 'MPS Supplier Code',
        PIC: 'PIC',
        fax: 'Fax',
        portName: 'Port Name',
        vesselETA: 'Vessel ETA',
        vesselETD: 'Vessel ETD',
      };

      const rfqData = result.rfqData[0];
      const lineItemData = result.lineItemData || [];

      const formatDate = (val: any) => {
        if (!val) return '';
        const d = moment(val);
        return d.isValid() ? d.format('DD/MM/YYYY') : '';
      };

      const data = {
        rfqRef: rfqData.serviceRfqRefNumber || '',
        rfqDate: formatDate(rfqData.serviceRfqDate),
        preferredCurrency: rfqData.currencyCode || '',
        vesselName: rfqData.vesselName || '',
        imoNumber: rfqData.vesselImoNumber || '',
        quoteByDate: formatDate(rfqData.quoteByDate),
        requestedDeliveryDate: formatDate(rfqData.requestedDeliveryDate),
        buyerDetails: {
          name: rfqData.buyerCompanyName || '',
          address: rfqData.buyerAddress || '',
          contact: rfqData.buyerContact || '',
          phone: rfqData.buyerPhone || '',
          email: rfqData.buyerEmail || '',
        },
        supplierDetails: {
          name: rfqData.supplierCompanyName || '',
          address: rfqData.supplierAddress || '',
          contact: rfqData.supplierName || '',
          phone: rfqData.supplierPhone || '',
          email: rfqData.supplierEmail || '',
        },
        freightForwarderDetails: {
          PIC: rfqData.freightForwarderPic || '',
          phone: rfqData.freightForwarderPhone || '',
          fax: rfqData.freightForwarderFax || '',
          email: rfqData.freightForwarderEmail || '',
          address: rfqData.freightForwarderAddress || '',
        },
        portAgentDetails: {
          name: rfqData.portAgentName || '',
          phone: rfqData.portAgentPhone || '',
          fax: rfqData.portAgentFax || '',
          email: rfqData.portAgentEmail || '',
          contact: rfqData.portAgentContact || '',
        },
        portDetails: {
          portName: rfqData.portName || '',
          vesselETA: formatDate(rfqData.vesselEta),
          vesselETD: formatDate(rfqData.vesselEtd),
        },
        lineItems: lineItemData.map((item: any, index: number) => ({
          srNo: index + 1,
          serviceCode: item.serviceCode || item.serviceName || '',
          serviceDescription: item.serviceDescription || '',
          qty: item.quantity || '',
          uom: item.uom || '',
          buyerComments: item.buyerComments || '',
        })),
      };

      const Excel = await import('exceljs');
      const fileSaverMod = await import('file-saver');
      const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
      const workbook = new Excel.Workbook();
      const ws = workbook.addWorksheet('Service RFQ');

      ws.mergeCells('A1:G1');
      const title = ws.getCell('A1');
      title.value = 'Service Request For Quotation';
      title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
      title.alignment = { horizontal: 'center', vertical: 'middle' };
      ws.addRow([]);

      const rfqHeader = ws.addRow(['SERVICE RFQ DETAILS']);
      rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
      rfqHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const rfqInfo = [
        ['RFQ Ref:', data.rfqRef, '', '', '', 'RFQ Date:', data.rfqDate],
        ['Preferred Currency:', data.preferredCurrency, '', '', '', 'Vessel Name:', data.vesselName],
        ['IMO Number:', data.imoNumber, '', '', '', 'Quote By Date:', data.quoteByDate],
        ['Requested Delivery Date:', data.requestedDeliveryDate],
      ];
      rfqInfo.forEach((r) => {
        const row = ws.addRow(r);
        row.eachCell((c: any) => (c.alignment = { vertical: 'middle' }));
      });
      ws.addRow([]);

      const bsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
      bsHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
      });
      ws.addRow([]);

      const buyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);

      const supplierEntries = Object.entries(data.supplierDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);

      const maxLen = Math.max(buyerEntries.length, supplierEntries.length);
      for (let i = 0; i < maxLen; i++) {
        const b = buyerEntries[i] || ['', ''];
        const s = supplierEntries[i] || ['', ''];
        ws.addRow([b[0], b[1], '', s[0], s[1]]);
      }
      ws.addRow([]);

      const ffHeader = ws.addRow(['Freight Forwarder Details', '', '', 'Port Agent Details']);
      ffHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E2EFDA' } };
      });
      ws.addRow([]);

      const ffEntries = Object.entries(data.freightForwarderDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);

      const paEntries = Object.entries(data.portAgentDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);

      const maxLen2 = Math.max(ffEntries.length, paEntries.length);
      for (let i = 0; i < maxLen2; i++) {
        const f = ffEntries[i] || ['', ''];
        const p = paEntries[i] || ['', ''];
        ws.addRow([f[0], f[1], '', p[0], p[1]]);
      }
      ws.addRow([]);

      const portHeader = ws.addRow(['Port Details']);
      portHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
      portHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const portEntries = Object.entries(data.portDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);
      portEntries.forEach((e) => ws.addRow(e));
      ws.addRow([]);

      const lineHeader = ws.addRow(['SERVICE LINE ITEMS']);
      lineHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DDEBF7' } };
      lineHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const itemHeader = ws.addRow(['Sr.No', 'Service Code', 'Service Description', 'Qty', 'UOM', 'Buyer Comments']);
      itemHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDD7EE' } };
        c.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });

      data.lineItems.forEach((item: any) => {
        const row = ws.addRow([
          item.srNo,
          item.serviceCode,
          item.serviceDescription,
          item.qty,
          item.uom,
          item.buyerComments,
        ]);
        row.eachCell((c: any) => {
          c.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });
      });

      ws.columns = [
        { width: 20 },
        { width: 25 },
        { width: 35 },
        { width: 10 },
        { width: 10 },
        { width: 30 },
        { width: 20 },
      ];

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, fileName);

      this.snack.open('Excel downloaded successfully.', 'OK', { duration: 3000 });
    } catch (error) {
      console.error('Error generating Service RFQ Excel:', error);
      this.snack.open('Error generating Excel. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async downloadDocumentDataExcel() {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const XLSX = await import('xlsx');

      const allData = await this.fetchAllServiceRfqsForExport();

      if (!allData || allData.length === 0) {
        this.snack.open('No data to export.', 'OK', { duration: 3000 });
        return;
      }

      const formattedData: any[] = [];
      allData.forEach((document: any) => {
        formattedData.push({
          'Reference': document.rfqRefNumber || '',
          'Vessel': document.vesselName || '',
          'Port Name': document.portName || '',
          'Total Suppliers': document.totalSuppliers || 0,
          'Status': document.docStatus || '',
          'RFQ Date': document.rfqDate ? moment(document.rfqDate).format('DD/MM/YYYY') : '',
          'Quote By Date': document.quotedByDate ? moment(document.quotedByDate).format('DD/MM/YYYY') : '',
          'Request Delivery Date': document.requestDeliveryDate ? moment(document.requestDeliveryDate).format('DD/MM/YYYY') : '',
          'Vessel ETA': document.vesselEta ? moment(document.vesselEta).format('DD/MM/YYYY') : '',
          'Vessel ETD': document.vesselEtd ? moment(document.vesselEtd).format('DD/MM/YYYY') : '',
          'Owner': document.assignedUsers || '',
        });
      });

      const ws: any = XLSX.utils.json_to_sheet(formattedData);
      const wb: any = XLSX.utils.book_new();

      ws['!cols'] = [
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 12 },
        { wch: 15 },
        { wch: 20 },
        { wch: 12 },
        { wch: 12 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, 'Service RFQ Data');

      const fileName = `Buyer_Service_RFQ_Export_${moment().format('YYYY-MM-DD')}.xlsx`;

      XLSX.writeFile(wb, fileName);

      this.snack.open('Export completed successfully.', 'OK', { duration: 3000 });
    } catch (error) {
      console.error('Error exporting Service RFQ data:', error);
      this.snack.open('Error exporting data. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async fetchAllServiceRfqsForExport(): Promise<any[]> {
    try {
      const fromDateFormatted = this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : null;
      const toDateFormatted = this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : null;

      const response = await this.settingsService.exportBuyerServiceRfq(
        this.searchParam,
        this.userId,
        this.docStatus,
        fromDateFormatted,
        toDateFormatted,
        1
      );

      if (response && response.rows) {
        return response.rows.map((row: any) => this.mapRowData(row));
      }
      return [];
    } catch (error) {
      console.error('Error fetching Service RFQ data for export:', error);
      return [];
    }
  }

  async rfqOperation(operation: string) {
    if (operation === 'archive') {
      if (this.selectedRfqDetails.length === 0) {
        this.snack.open('Please select at least one Service RFQ.', 'OK', { duration: 3000 });
        return;
      }
      await this.archiveSelectedRfqs();
    } else if (operation === 'unarchive') {
      if (this.selectedArchivedRfqDetails.length === 0) {
        this.snack.open('Please select at least one archived Service RFQ.', 'OK', { duration: 3000 });
        return;
      }
      await this.unArchiveSelectedRfqs();
    }
  }

  async archiveSelectedRfqs() {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const response = await this.settingsService.buyerBulkArchiveServiceRfq(
        this.selectedRfq,
        this.userId
      );

      if (response && response.success) {
        this.snack.open(`${this.selectedRfqDetails.length} Service RFQ(s) archived successfully.`, 'OK', { duration: 3000 });
        this.selectedRfq = [];
        this.selectedRfqDetails = [];
        await this.loadData();
        if (this.archivedLoaded) {
          await this.loadArchivedData();
        }
      } else {
        this.snack.open('Failed to archive Service RFQs.', 'OK', { duration: 3000 });
      }
    } catch (error) {
      console.error('Error archiving Service RFQs:', error);
      this.snack.open('Error archiving Service RFQs. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async unArchiveSelectedRfqs() {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const response = await this.settingsService.buyerBulkUnArchiveServiceRfq(
        this.selectedArchivedRfq,
        this.userId
      );

      if (response && response.success) {
        this.snack.open(`${this.selectedArchivedRfqDetails.length} Service RFQ(s) restored successfully.`, 'OK', { duration: 3000 });
        this.selectedArchivedRfq = [];
        this.selectedArchivedRfqDetails = [];
        await this.loadData();
        await this.loadArchivedData();
      } else {
        this.snack.open('Failed to restore Service RFQs.', 'OK', { duration: 3000 });
      }
    } catch (error) {
      console.error('Error restoring Service RFQs:', error);
      this.snack.open('Error restoring Service RFQs. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async RestoreRfq(isConfirmed: boolean, row: any) {
    if (isConfirmed && row && row.serviceRfqId) {
      this.showLoader = true;
      this.cdr.markForCheck();

      try {
        const response = await this.settingsService.buyerUnArchiveServiceRfq(
          row.serviceRfqId,
          this.userId
        );

        if (response && response.success) {
          this.snack.open('Service RFQ restored successfully.', 'OK', { duration: 3000 });
          await this.loadData();
          await this.loadArchivedData();
        } else {
          this.snack.open('Failed to restore Service RFQ.', 'OK', { duration: 3000 });
        }
      } catch (error) {
        console.error('Error restoring Service RFQ:', error);
        this.snack.open('Error restoring Service RFQ. Please try again.', 'OK', { duration: 3000 });
      } finally {
        this.showLoader = false;
        this.cdr.markForCheck();
      }
    }
  }

  openCancellationBox(serviceRfqId: number) {
    this.selectedServiceRfqId = serviceRfqId;
    this.selectedRfq = [serviceRfqId];
    this.showConfirmationDialogue = true;
  }

  async save(isConfirmed: boolean) {
    if (isConfirmed) {
      this.showLoader = true;
      this.cdr.markForCheck();

      if (this.cancelReason === 'Other') {
        this.cancelReason = this.customReason.trim();
      }

      try {
        await this.settingsService.cancelBuyerServiceRfq(
          this.selectedServiceRfqId,
          this.userId,
          13 // 13 = Cancelled in rfqStatusMaster
        );

        this.snack.open('Service RFQ Cancelled', 'OK', { duration: 3000 });
        this.showConfirmationDialogue = false;
        this.cancelReason = '';
        this.customReason = '';
        this.selectedRfq = [];
        await this.loadData();
      } catch (error) {
        console.error('Error cancelling Service RFQ:', error);
        this.snack.open('Error cancelling Service RFQ. Please try again.', 'OK', { duration: 3000 });
      } finally {
        this.showLoader = false;
        this.cdr.markForCheck();
      }
    } else {
      this.selectedRfq = [];
      this.showConfirmationDialogue = false;
    }
  }

  cancelDialog() {
    this.selectedRfq = [];
    this.cancelReason = '';
    this.customReason = '';
    this.showConfirmationDialogue = false;
  }

  async archiveSingleRfq(row: any) {
    if (row && row.serviceRfqId) {
      this.showLoader = true;
      this.cdr.markForCheck();

      try {
        const response = await this.settingsService.buyerArchiveServiceRfq(
          row.serviceRfqId,
          this.userId
        );

        if (response && response.success) {
          this.snack.open('Service RFQ archived successfully.', 'OK', { duration: 3000 });
          await this.loadData();
          if (this.archivedLoaded) {
            await this.loadArchivedData();
          }
        } else {
          this.snack.open('Failed to archive Service RFQ.', 'OK', { duration: 3000 });
        }
      } catch (error) {
        console.error('Error archiving Service RFQ:', error);
        this.snack.open('Error archiving Service RFQ. Please try again.', 'OK', { duration: 3000 });
      } finally {
        this.showLoader = false;
        this.cdr.markForCheck();
      }
    }
  }
}
